module.exports = __webpack_public_path__ + "files/847c885f004afdc067a41ab42aa160bf.png";